var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showInput)?_c('input',{staticClass:"filters-popup__filter-input el-inp",attrs:{"type":"text","placeholder":_vm.$t('value')},domProps:{"value":_vm.filter.value},on:{"keyup":_vm.changeValue}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }